import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Clock, Trash2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useLang } from "../../lib/i18n";
import { fmtDate, todayStr } from "../../lib/helpers";
import { Section, Empty, StatusBadge } from "../common";

export function MyHours({ projectId }) {
  const { t, lang } = useLang();
  const [items, setItems] = useState([]);
  const [f, setF] = useState({ date: todayStr(), hours: "", notes: "" });
  const load = useCallback(() => api.get(`/projects/${projectId}/time`).then((r) => setItems(r.data)).catch(() => {}), [projectId]);
  useEffect(() => { load(); }, [load]);
  const add = async () => {
    try { await api.post(`/projects/${projectId}/time`, { ...f, hours: Number(f.hours) }); setF({ ...f, hours: "", notes: "" }); toast.success(t("Hours sent for approval", "Horas enviadas para aprobación")); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const del = async (x) => { await api.delete(`/time/${x.id}`); load(); };
  return (
    <Section title={t("My hours", "Mis horas")} count={items.length} testid="my-hours">
      <div className="grid gap-2 p-4">
        <div className="grid grid-cols-2 gap-2">
          <input className="inp" type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} data-testid="my-hours-date" />
          <input className="inp" type="number" step="0.25" min="0" max="24" placeholder={t("Hours", "Horas")} value={f.hours} onChange={(e) => setF({ ...f, hours: e.target.value })} data-testid="my-hours-hours" />
        </div>
        <input className="inp" placeholder={t("What did you work on?", "¿En qué trabajó?")} value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} data-testid="my-hours-notes" />
        <button className="btn-primary h-12" disabled={!(Number(f.hours) > 0)} onClick={add} data-testid="my-hours-add-btn"><Clock className="w-5 h-5" /> {t("Log my hours", "Registrar mis horas")}</button>
      </div>
      {!items.length && <Empty text={t("No hours logged yet", "Aún no hay horas")} />}
      {items.map((x) => (
        <div key={x.id} className="px-4 py-2 border-t flex items-center gap-2 text-sm" data-testid={`my-hours-row-${x.id}`}>
          <div className="flex-1 min-w-0"><b>{x.hours}h</b> · {fmtDate(x.date, lang)}<div className="text-xs text-slate-500 truncate">{x.notes}</div></div>
          <StatusBadge status={x.status} />
          {x.status === "pending" && <button className="btn-ghost btn-sm" onClick={() => del(x)} aria-label="delete" data-testid={`my-hours-delete-${x.id}`}><Trash2 className="w-4 h-4" /></button>}
        </div>
      ))}
    </Section>
  );
}
